import { Component, ViewChild } from '@angular/core';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ExpenseTripFormComponent } from '../expense-trip-form/expense-trip-form.component';

@Component({
  selector: 'app-expense-trip',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule],
  templateUrl: './expense-trip.component.html',
  styleUrl: './expense-trip.component.scss'
})
export class ExpenseTripComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  HolidayData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private modalService: NgbModal,
    private toast: ToastService,
    private session: SessionService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_TripMaster_SelectUpdate();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_TripMaster_SelectUpdate() {
    this.isDisabled = true;
    this.expense.ESS_TripMaster_SelectUpdate({ SelectType: 'S', ESS_TripMasterID: 0,EmpMasterId : this.session.GetUserDetails().UserId }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTrip(ID: any) {
    const modalRef = this.modalService.open(ExpenseTripFormComponent, { backdrop: 'static', });
    modalRef.componentInstance.ID = ID;
    modalRef.result.then(
      (result: any) => { 
        if(result !=  undefined && result){
          this.ESS_TripMaster_SelectUpdate();
        }
      },
      () => { }
    );
  }
}
